import { Vue, Component, Prop } from 'vue-property-decorator'
import DeliverySvg from '~/assets/svg/delivery.svg?inline'
import PaymentSvg from '~/assets/svg/payment.svg?inline'

@Component
export default class ProductDeliveryInfo extends Vue {
  @Prop({ required: false })
  readonly deliveryPrice?: number

  @Prop({ required: false })
  readonly freeDeliveryFrom?: number

  @Prop({ required: false })
  readonly byPrescription?: boolean

  @Prop({ required: false })
  readonly eCertificateFlag?: boolean

  @Prop({ required: false })
  readonly hasPickup?: boolean

  @Prop({ required: false })
  readonly hasDelivery?: boolean

  @Prop({ required: false })
  readonly paymentInfoPickup?: string

  @Prop({ required: false })
  readonly paymentInfoDelivery?: string

  render() {
    return (
      <div class="product-delivery-info">
        <div class="product-delivery-info__row">
          <div class="product-delivery-info__col-content">
            {this.hasPickup && <div class="product-delivery-info__delivery-item">
              <div class="product-delivery-info__delivery-item-header">
                <h2 class="product-delivery-info__delivery-item-header-title">Самовывоз</h2>
              </div>
              <div class="product-delivery-info__delivery-item-content">
                <DeliverySvg class="product-delivery-info__delivery-item-content-icon" />
                <p class="product-delivery-info__delivery-item-content-text">Доступно из <span>пунктов выдачи</span> бесплатно при заказе на любую сумму</p>
              </div>
              <div class="product-delivery-info__delivery-item-content2">
                <PaymentSvg class="product-delivery-info__delivery-item-content-icon" />
                <p class="product-delivery-info__delivery-item-content-text">{this.paymentInfoPickup}</p>
              </div>
            </div>}
            {!this.byPrescription && !this.eCertificateFlag && this.hasDelivery &&  <div class="product-delivery-info__delivery-item">
              <div class="product-delivery-info__delivery-item-header">
                <h2 class="product-delivery-info__delivery-item-header-title">Доставка</h2>
              </div>
              <div class="product-delivery-info__delivery-item-content">
                <DeliverySvg class="product-delivery-info__delivery-item-content-icon" />
                <p class="product-delivery-info__delivery-item-content-text">Доставка <span class="">на дом</span> бесплатно от {this.freeDeliveryFrom} ₽ на следующий день и {this.deliveryPrice} ₽ в день 
                                                                                                оформления заказа от любой суммы или при заказе до {this.freeDeliveryFrom} ₽</p>
              </div>
              <div class="product-delivery-info__delivery-item-content2">
                <PaymentSvg class="product-delivery-info__delivery-item-content-icon" />
                <p class="product-delivery-info__delivery-item-content-text">{this.paymentInfoDelivery}</p>
              </div>
            </div>}
          </div>
        </div>
      </div>
    )
  }
}
